<template>
  <aside
    id="sidebar"
    class="left-menu"
    :class="{
      'collapsed': isCollapsed,
      'toggled': isMobileOpen
    }"
  >
    <!-- โลโก้: ปักอยู่บน ไม่เลื่อนตามเมนู -->
    <div class="sidebar-logo d-flex justify-content-between align-items-center flex-shrink-0">
      <a href="#" class="brand-link d-flex align-items-center gap-2">
        <i class="fa-solid fa-utensils brand-ico" />
        <span class="brand-text d-flex flex-column lh-sm">
          <span>{{ $ln($brand) }}</span>
          <small class="fw-normal opacity-50" style="font-size: 0.65rem; letter-spacing: 1px;">{{ $appName }}</small>
        </span>
      </a>
      <!-- Close button for mobile -->
      <!-- <button
        class="btn btn-sm d-md-none text-muted"
        @click="$emit('close-mobile')"
      >
        <i class="fa-solid fa-times"></i>
      </button> -->
    </div>
    <!-- เฉพาะเมนูที่เลื่อน scroll -->
    <div class="flex-grow-1 overflow-auto sidebar-scroll">
      <!-- Sidebar Navigation -->
      <ul class="sidebar-nav">
        <!-- ZONE 1: OPERATIONAL -->
        <li class="sidebar-header">
          <b>
            {{ $t('Operational') }}
          </b>
        </li>
        <li class="sidebar-item">
          <router-link
            :class="['sidebar-link', $route.name === 'dashboards'? 'active': '']"
            to="/"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-gauge-high" />
            {{ $t('Dashboard') }}
          </router-link>
          <router-link
            :class="['sidebar-link', $route.name === 'pos-register'? 'active': '']"
            to="/pos-register"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-cash-register" />
            {{ $t('POS (Point of Sale)') }}
          </router-link>
          <router-link
            v-if="canSee('/kds-register')"
            :class="['sidebar-link', $route.name === 'kds-register'? 'active': '']"
            to="/kds-register"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-desktop" />
            {{ $t('KDS (Kitchen Display System)') }}
          </router-link>
          <router-link
            :class="['sidebar-link', $route.name === 'shift-management'? 'active': '']"
            to="/shift-management"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-business-time" />
            {{ $t('Shift Management') }}
          </router-link>
          <a
            href="#"
            class="sidebar-link collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#tablesAndZone"
            aria-expanded="false"
            aria-controls="tablesAndZone"
          >
            <i class="menu-ico fa-solid fa-chair" />
            {{ $t('Table & Zone Management') }}
          </a>
          <ul id="tablesAndZone" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
            <li class="sidebar-item">
              <router-link
                class="ps-5 pe-0"
                :class="['sidebar-link', $route.name === 'zones'? 'active': '']"
                to="/zones"
                @click="handleLinkClick"
              >
                {{ $t('Zone Management') }}
              </router-link>
              <router-link
                class="ps-5"
                :class="['sidebar-link', $route.name === 'tables'? 'active': '']"
                to="/tables"
                @click="handleLinkClick"
              >
                {{ $t('Table Management') }}
              </router-link>
            </li>
          </ul>
          <!-- <router-link
            :class="['sidebar-link', $route.name === 'reservations'? 'active': '']"
            to="/reservations"
            @click="handleLinkClick"
          >
            {{ $t('Reservations') }}
          </router-link> -->
          <router-link
            :class="['sidebar-link', $route.name === 'bill-management'? 'active': '']"
            to="/bill-management"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-receipt" />
            {{ $t('Bill Management') }}
          </router-link>
          <router-link
            v-if="canSee('/tax-invoices')"
            :class="['sidebar-link', $route.name === 'tax-invoices'? 'active': '']"
            to="/tax-invoices"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-file-invoice-dollar" />
            {{ $t('Tax Invoice Management') }}
          </router-link>
        </li>
        <!-- ZONE 2: BACK OFFICE -->
        <li class="sidebar-header">
          <b>
            {{ $t('Back Office') }}
          </b>
        </li>
        <li class="sidebar-item">
          <a
            href="#"
            class="sidebar-link collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#product"
            aria-expanded="false"
            aria-controls="product"
          >
            <i class="menu-ico fa-solid fa-utensils" />
            {{ $t('Menu Management') }}
          </a>
          <ul id="product" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
            <li class="sidebar-item">
              <router-link
                class="ps-5"
                :class="['sidebar-link', $route.name === 'products'? 'active': '']"
                to="/products"
                @click="handleLinkClick"
              >
                <!-- <i class="fa-solid fa-carrot me-2" /> -->
                {{ $t('Product Management') }}
              </router-link>
              <router-link
                class="ps-5 pe-0"
                :class="['sidebar-link', $route.name === 'modifiers'? 'active': '']"
                to="/modifiers"
                @click="handleLinkClick"
              >
                {{ $t('Option Group Management') }}
              </router-link>
              <router-link
                class="ps-5 pe-0"
                :class="['sidebar-link', $route.name === 'attributes'? 'active': '']"
                to="/attributes"
                @click="handleLinkClick"
              >
                {{ $t('Product Variant Management') }}
              </router-link>
            </li>
          </ul>
          <router-link
            :class="['sidebar-link', $route.name === 'customers'? 'active': '']"
            to="/customers"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-id-card" />
            {{ $t('Customer Membership') }}
          </router-link>
          <router-link
            v-if="canSee('/customer-groups')"
            :class="['sidebar-link', $route.name === 'customer-groups'? 'active': '']"
            to="/customer-groups"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-user-group" />
            {{ $t('Customer Group Management') }}
          </router-link>
          <router-link
            v-if="canSee('/loyalty/programs')"
            :class="['sidebar-link', $route.name === 'loyalty-programs'? 'active': '']"
            to="/loyalty/programs"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-gift" />
            {{ $t('Loyalty Program Management') }}
          </router-link>
          <router-link
            v-if="canSee('/promotions')"
            :class="['sidebar-link', $route.name === 'promotions'? 'active': '']"
            to="/promotions"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-tags" />
            {{ $t('Promotion Management') }}
          </router-link>
          <a
            v-if="canSee('/inventories')"
            href="#"
            class="sidebar-link collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#inventory"
            aria-expanded="false"
            aria-controls="inventory"
          >
            <i class="menu-ico fa-solid fa-warehouse" />
            {{ $t('Raw Material & Production Management') }}
          </a>
          <ul v-if="canSee('/inventories')" id="inventory" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
            <li class="sidebar-item">
              <router-link
                class="ps-5"
                :class="['sidebar-link', $route.name === 'inventories'? 'active': '']"
                to="/inventories"
                @click="handleLinkClick"
              >
                <!-- <i class="fa-solid fa-carrot me-2" /> -->
                {{ $t('Raw Material Management') }}
              </router-link>
              <router-link
                class="ps-5"
                :class="['sidebar-link', $route.name === 'recipes'? 'active': '']"
                to="/recipes"
                @click="handleLinkClick"
              >
                <!-- <i class="fa-solid fa-book-open me-2" /> -->
                {{ $t('Recipe Management') }}
              </router-link>
              <router-link
                class="ps-5"
                :class="['sidebar-link', $route.name === 'production-batches'? 'active': '']"
                to="/production-batches"
                @click="handleLinkClick"
              >
                <!-- <i class="fa-solid fa-file-lines me-2" /> -->
                {{ $t('Production Batch Management') }}
              </router-link>
              <router-link
                class="ps-5 pe-0"
                :class="['sidebar-link', $route.name === 'inventory-goods-receipts'? 'active': '']"
                to="/inventory-goods-receipts"
                @click="handleLinkClick"
              >
                <!-- <i class="fa-solid fa-truck-ramp-box me-2" /> -->
                {{ $t('Goods Receipt Management') }}
              </router-link>
              <router-link
                class="ps-5 pe-0"
                :class="['sidebar-link', $route.name === 'stock-adjustments'? 'active': '']"
                to="/stock-adjustments"
                @click="handleLinkClick"
              >
                <!-- <i class="fa-solid fa-clipboard-check me-2" /> -->
                {{ $t('Stock Management') }}
              </router-link>
              <!-- <router-link
                class="ps-5 pe-0"
                :class="['sidebar-link', $route.name === 'inventory-composites'? 'active': '']"
                to="/inventory-composites"
              >
                <i class="fa-solid fa-right-left me-2" />
                {{ $t('Transfer') }}
              </router-link> -->
            </li>
          </ul>
          <router-link
            v-if="canSee('/supplier')"
            :class="['sidebar-link', $route.name === 'supplier'? 'active': '']"
            to="/supplier"
                @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-truck-field" />
            {{ $t('Supplier Management') }}
          </router-link>
        </li>
        <!-- ZONE 3: CONFIGURATION -->
        <li class="sidebar-header">
          <b>
            {{ $t('System & Settings') }}
          </b>
        </li>
        <li class="sidebar-item">
          <a
            href="#"
            class="sidebar-link collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#usersAndRoles"
            aria-expanded="false"
            aria-controls="usersAndRoles"
          >
            <i class="menu-ico fa-solid fa-users-gear" />
            {{ $t('User & Role Management') }}
          </a>
          <ul id="usersAndRoles" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
            <li class="sidebar-item">
              <router-link
                class="ps-5 pe-0"
                :class="['sidebar-link', $route.name === 'users'? 'active': '']"
                to="/users"
                @click="handleLinkClick"
              >
                {{ $t('User Management') }}
              </router-link>
              <router-link
                class="ps-5"
                :class="['sidebar-link', $route.name === 'roles'? 'active': '']"
                to="/roles"
                @click="handleLinkClick"
              >
                {{ $t('Role Management') }}
              </router-link>
            </li>
          </ul>
          <router-link
            :class="['sidebar-link', $route.name === 'branches'? 'active': '']"
            to="/branches"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-code-branch" />
            {{ $t('Branch Management') }}
          </router-link>
          <router-link
            v-if="canSee('/expenses')"
            :class="['sidebar-link', $route.name === 'expenses'? 'active': '']"
            to="/expenses"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-receipt" />
            {{ $t('Expense Management') }}
          </router-link>
          <router-link
            :class="['sidebar-link', $route.path.startsWith('/reports') ? 'active': '']"
            to="/reports"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-chart-pie" />
            {{ $t('Reports') }}
          </router-link>
          <router-link
            :class="['sidebar-link', $route.name === 'settings'? 'active': '']"
            to="/settings"
            @click="handleLinkClick"
          >
            <i class="menu-ico fa-solid fa-gear" />
            {{ $t('Settings') }}
          </router-link>
        </li>


        <!-- <li class="sidebar-header text-black">
          <b>
            {{ $t('Multi Level Nav') }}
          </b>
        </li>
        <li class="sidebar-item">
          <a href="#" class="sidebar-link collapsed" data-bs-toggle="collapse" data-bs-target="#multi"
            aria-expanded="false" aria-controls="multi">
            <i class="fa-solid fa-share-nodes pe-2"></i>
            Multi Level
          </a>
          <ul id="multi" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
            <li class="sidebar-item">
            <a href="#" class="sidebar-link collapsed" data-bs-toggle="collapse"
              data-bs-target="#multi-two" aria-expanded="false" aria-controls="multi-two">
              Two Links
            </a>
            <ul id="multi-two" class="sidebar-dropdown list-unstyled collapse">
              <li class="sidebar-item">
                <a href="#" class="sidebar-link">Link 1</a>
              </li>
              <li class="sidebar-item">
                <a href="#" class="sidebar-link">Link 2</a>
              </li>
            </ul>
            </li>
          </ul>
        </li> -->
      </ul>
    </div>
  </aside>
</template>

<script>
export default {
  name: "LeftMenu",
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isMobileOpen: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  methods: {
    /**
     * เมนูนี้โชว์ไหม — อ่าน meta.feature ของ route ปลายทาง (router/index.js ที่เดียว ไม่ map ซ้ำในเมนู)
     * แพ็กไม่มี → ซ่อน · เข้าทาง URL ก็ยังโดน layout ขึ้นกุญแจ และ API บล็อกอยู่ดี
     */
    canSee(path) {
      const feature = this.$router.resolve(path).meta?.feature;
      return !feature || this.$hasFeature(feature);
    },
    handleLinkClick() {
      // On mobile, close sidebar when a link is clicked
      if (this.isMobileOpen) {
        this.$emit('close-mobile');
      }
    }
  }
}
</script>
